import { CompareQueryProperty, SortBy } from '@modules/quantify/store/types';
import { TimeUnit } from 'generated/graphql';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';

export const COMMON = 'Common';

export const OTHERS_DATA_POINT_PIE_CHART = 'Others';
export const UNASSIGNED_SENTIMENT_DATA_POINT_PIE_CHART = 'Not Detected';

export const TIME = 'Time';

export const DEFAULT_QUANTIFY_SORT_BY: SortBy = {
  field: 'value',
  isAsc: false,
};

export const DEFAULT_COMPARE_SORT_BY: SortBy = {
  field: 'absValueDelta',
  isAsc: false,
};

export const DEFAULT_QUANTIFY_SORT_BY_FOR_TOP_SELECTION: SortBy = {
  field: 'value',
  isAsc: false,
};

export const DEFAULT_COMPARE_FILTER_A_NAME = 'Filter A';
export const DEFAULT_COMPARE_FILTER_B_NAME = 'Filter B';
export const DEFAULT_COMPARE_DURATION_A_NAME = 'Duration A';
export const DEFAULT_COMPARE_DURATION_B_NAME = 'Duration B';

export const ALL = 'all';

export const RELATED_TO_TRACKED_KEYWORD = 'related_to_tracked_keyword';

export const RELATED_TO_TRACKED_KEYWORD_OPTION = {
  label: 'Related to tracked keyword',
  value: RELATED_TO_TRACKED_KEYWORD,
};

export const DEFAULT_QUANTIFY_TOP_SELECTION_VALUE = 10;

export const TOP_QUANTIFY_SELECTION_OPTIONS = [5, 10, 15];

export const DEFAULT_ANOMALY_THRESHOLD = 1.5;

export const MIN_ANOMALY_THRESHOLD = 1;

export const MAX_ANOMALY_THRESHOLD = 3;

export const MAX_WEEKLY_BUCKET_COUNT_FOR_TREND_CHART = 20;

export const MAX_DAILY_BUCKET_COUNT_FOR_TREND_CHART = 35;

export const MIN_TIME_BUCKET_COUNT_FOR_TREND_CHART = 1;

export const ANOMALY_HELPCENTER_URL =
  'https://helpcenter.enterpret.com/en/articles/6446366-anomaly';

export const ZSCORE_HELPCENTER_URL =
  'https://helpcenter.enterpret.com/en/articles/6446366-anomaly#h_975fc7931d';

export const JOIN_QUERY_ALIAS = 'join-query-alias';

export const DENOMINATOR_QUERY_ALIAS = 'denominator-query-alias';

export const DEFAULT_COMPARE_TO_PREVIOUS_PERIOD: Required<
  Pick<CompareQueryProperty, 'previousPeriod'>
> &
  CompareQueryProperty = {
  previousPeriod: {
    value: 1,
    unit: TimeUnit.Month,
  },
};

export const DEFAULT_COMPARE_TO_CUSTOM_LAST_DURATION: Required<
  Pick<CompareQueryProperty, 'timerange'>
> &
  CompareQueryProperty = {
  timerange: {
    relative: {
      value: 1,
      unit: TimeUnit.Month,
    },
  },
};

export const DEFAULT_COMPARE_TO_WHERECLAUSE_FILTER: CompareQueryProperty = {
  whereClause: EmptyWhereClause,
};

export const QUANTIFY_COOCCURRING_HELP_DESK_ARTICLE =
  'https://helpcenter.enterpret.com/en/articles/8176680-understanding-tracked-keyword-reason-relations#h_0b3ad961d0';
